import React, { useState } from 'react';
import { Copy, Printer, RefreshCw, Check } from 'lucide-react';

const CommDocumentPreview = ({ content, onIterate }) => {
  const [copied, setCopied] = useState(false);

  if (!content) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback
      const ta = document.createElement('textarea');
      ta.value = content;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html><head><title>Document Communication ITRIIA</title>
      <style>body{font-family:'Inter',sans-serif;padding:40px;max-width:800px;margin:0 auto;line-height:1.6;color:#1f2937;}</style>
      </head><body>${content.replace(/\n/g, '<br>')}</body></html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div style={{
      background: 'var(--card-bg)', border: '1px solid var(--card-border)',
      borderRadius: 10, marginTop: 8, overflow: 'hidden',
      borderLeft: '3px solid #10b981',
    }}>
      {/* Toolbar */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '6px 12px', borderBottom: '1px solid var(--card-border)',
        background: 'var(--input-bg)',
      }}>
        <span style={{ fontSize: 11, fontWeight: 600, color: '#10b981' }}>Document généré</span>
        <div style={{ display: 'flex', gap: 4 }}>
          <button onClick={handleCopy} title="Copier" style={btnStyle}>
            {copied ? <Check size={13} color="#10b981" /> : <Copy size={13} />}
          </button>
          <button onClick={handlePrint} title="Exporter PDF" style={btnStyle}>
            <Printer size={13} />
          </button>
          {onIterate && (
            <button onClick={onIterate} title="Affiner" style={btnStyle}>
              <RefreshCw size={13} />
            </button>
          )}
        </div>
      </div>

      {/* Content */}
      <div style={{
        padding: '12px 16px', fontSize: 13, lineHeight: 1.6,
        color: 'var(--text)', whiteSpace: 'pre-wrap', maxHeight: 300,
        overflowY: 'auto',
      }}>
        {content}
      </div>
    </div>
  );
};

const btnStyle = {
  background: 'none', border: '1px solid var(--card-border)',
  borderRadius: 5, padding: '4px 6px', cursor: 'pointer',
  color: 'var(--text-secondary)', display: 'flex', alignItems: 'center',
  transition: 'all 0.15s',
};

export default CommDocumentPreview;
